import type { MappedDynamicGroupResourceApi } from '../../../shared-inlined/dynamicGroups.model';
import type { DeploymentDevicesDynamicGroupQuery } from '../../models/deployment/deploymentRequest.model';
import { convertSearchRequestToAdvancedSearchInput } from '../utils/deployment.util';

export function mapDeploymentDevicesDynamicGroupResponse(
  dynamicGroupResource: MappedDynamicGroupResourceApi,
): DeploymentDevicesDynamicGroupQuery {
  return {
    base: dynamicGroupResource.searchRequest,
    filters: convertSearchRequestToAdvancedSearchInput(dynamicGroupResource.searchRequest),
  };
}
